<template>

</template>

<script>
    import PreviewElement from "./PreviewElement";
    import LeadFormElement from "../../components/pagesbuilder/elements/LeadFormElement";
    import {mapState, mapActions} from "vuex";

    export default {
        name: "PreviewLeadWrapperElement",
        mixins: [
            PreviewElement,
            LeadFormElement
        ],
        computed: {
            ...mapState('user', [
                'isEUCustomer'
            ]),
        },
        methods: {
            ...mapActions( 'common', [
                'postNewsletterFormData'
            ]),
            addListeners () {
                const newsletterForm = this.elementNode;
                const formTag = this.getTags();

                // Find submit element. Can be either button or input with submit type
                const submit = Array.from(this.elementNode.elements).find( el => el.type === 'submit');

                this.elementNode.addEventListener('submit', (e) => {
                    e.preventDefault();
                    const postData = this.getPostData();

                    submit.setAttribute('disabled', '');

                    this.postNewsletterFormData({postData, formTag})
                        .then(({data}) => {
                            if (data.success) {
                                this.notifyWrapperForSubmission();
                            } else {
                                displayError(data.errors);
                            }
                            submit.removeAttribute('disabled');
                        })
                        .catch((error) => {
                            console.log(error);
                            submit.removeAttribute('disabled');
                            displayError();
                        });
                });
            },
            getPostData () {
                const emailInput = this.elementNode.querySelector('.js-email-input');
                const optinCheckbox = this.elementNode.querySelector('.js-optin-checkbox');

                const postData = {};
                if (emailInput) {
                    postData["email"] = emailInput.value;
                }
                if (optinCheckbox) {
                    postData["optin"] = optinCheckbox.checked;
                }
                if(this.isEUCustomer){
                    postData["eu_customer"] = this.isEUCustomer;
                }
                return postData;
            },
            notifyWrapperForSubmission() {
                const wrapper = this.elementNode.closest("[data-node-type='lead-form-wrapper']");
                if (wrapper) {
                    const wrapperState = this.findNodeState(wrapper.id);
                    wrapperState.setFormStatus('submitted');
                }
            }
        }
    }
</script>

